import { ActionTypes } from './actions';

export const updatePost = (post) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.POST_UPDATE,
      postId: post.id,
      changes: post,
    });
  };
};

export const updatePosts = (posts) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.POST_SET_MANY,
      posts,
    });
  };
};
